export enum FeeCalculatorRenderFieldType {
  Toggle = "Toggle",
  Radio = "Radio",
  Input = "Input",
  CurrencyInput = "CurrencyInput",
  NumberInput = "NumberInput",
  AutoCalculated = "AutoCalculated",
  Custom = "Custom",
}
